var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1C7.372 1 7.24398 1.04898 7.14648 1.14648C6.95148 1.34148 6.95148 1.65852 7.14648 1.85352L8.45703 3.16406C6.96911 4.25592 6 6.01275 6 8H18C18 6.01275 17.0309 4.25592 15.543 3.16406L16.8535 1.85352C17.0485 1.65752 17.0485 1.34248 16.8535 1.14648C16.6585 0.951484 16.3415 0.951484 16.1465 1.14648L14.6641 2.62891C13.8606 2.22956 12.9582 2 12 2C11.0418 2 10.1394 2.22956 9.33594 2.62891L7.85352 1.14648C7.75602 1.04898 7.628 1 7.5 1ZM9 5H10V6H9V5ZM14 5H15V6H14V5ZM4 9C3.448 9 3 9.448 3 10V16C3 16.552 3.448 17 4 17C4.552 17 5 16.552 5 16V10C5 9.448 4.552 9 4 9ZM6 9V17C6 17.552 6.448 18 7 18H8V21.5C8 22.328 8.672 23 9.5 23C10.328 23 11 22.328 11 21.5V18H13V21.5C13 22.328 13.672 23 14.5 23C15.328 23 16 22.328 16 21.5V18H17C17.552 18 18 17.552 18 17V9H6ZM20 9C19.448 9 19 9.448 19 10V16C19 16.552 19.448 17 20 17C20.552 17 21 16.552 21 16V10C21 9.448 20.552 9 20 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.98abb74c573276ad18c400bcf87537fe.svg";
export { ForwardRef as ReactComponent };